import { motion } from "framer-motion";
import { SpecimenLabel } from "../SpecimenLabel";
import platformsCard from "@/assets/platforms-card.jpg";

const FORMATS = [
  { icon: "📱", title: "LinkedIn Post", description: "Hook + Story + CTA" },
  { icon: "📊", title: "Case Study", description: "Problem / Solution / Result" },
  { icon: "🎠", title: "Carousel", description: "5-slide story arc" },
  { icon: "💬", title: "One-Liner", description: "Punchy quote for ads" },
  { icon: "📧", title: "Email", description: "Newsletter-ready block" },
  { icon: "🎯", title: "Deck Bullets", description: "Presentation points" },
];

export const FramePlatformMatrix = () => {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <SpecimenLabel text="FORMAT INVENTORY" className="mb-4 block" />
          <h2 className="font-editorial text-3xl md:text-4xl text-foreground mb-4">
            6 formats. One input. Zero reformatting.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-16">
          <div className="grid grid-cols-2 gap-4">
            {FORMATS.map((format, i) => (
              <motion.div
                key={format.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="relative p-6 border border-border hover:border-brand-200 transition-colors group"
              >
                <div className="text-3xl mb-3">{format.icon}</div>
                <h3 className="font-editorial text-lg text-foreground mb-1 group-hover:text-brand-600 transition-colors">
                  {format.title}
                </h3>
                <p className="text-muted-foreground text-sm">{format.description}</p>
              </motion.div>
            ))}
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="hidden md:block"
          >
            <img src={platformsCard} alt="Platform formats" width={560} height={560} className="rounded-xl shadow-2xl shadow-brand-500/10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
